export default class Interval {
  static begin(method, time) {
    const instance = new Interval(method, time);
    instance.start();
    return instance;
  }

  constructor(method, time) {
    this.method = method;
    this.time = time;
  }

  start() {
    this.stop();
    this.handle = setInterval(this.method, this.time);
  }

  stop() {
    clearInterval(this.handle);
  }
}
